import React from 'react';
import './ResultsDisplay.css';

const ResultsDisplay = ({ results, loading }) => {
  if (loading) {
    return (
      <div className="results-loading">
        <div className="spinner"></div>
        <p>Расчет массы и количества коробок...</p>
      </div>
    );
  }

  if (!results) {
    return (
      <div className="results-empty">
        <p>Расчетов пока нет. Выберите устройства и нажмите "Рассчитать" для просмотра результатов.</p>
      </div>
    );
  }

  return (
    <div className="results-container">
      <div className="results-summary">
         <h3>Сводка</h3>
        <div className="total-mass">
          <span className="total-label">Общая масса:</span>
          <span className="total-value">{results.total_mass.toFixed(2)} кг</span>
        </div>
        <div className="total-boxes">
          <span className="total-label">Всего коробок:</span>
          <span className="total-value">
            {results.results.reduce((sum, item) => sum + item.box_quantity, 0)}
          </span>
        </div>
      </div>

      <div className="results-details">
         <h3>Детальные результаты</h3>
        <div className="results-table-container">
          <table className="results-table">
            <thead>
              <tr>
                <th>Тип устройства</th>
                <th>Количество</th>
                <th>Коробки</th>
                <th>Размер коробки</th>
                <th>Масса (кг)</th>
              </tr>
            </thead>
            <tbody>
              {results.results.map((item, index) => (
                 <tr key={index}>
                  <td>{item.device_type}</td>
                  <td>{item.quantity || (item.device_type.includes('TD BLE') ? 
                    (item.box_quantity * (item.device_type.includes('1000') ? 4 : 8)) :
                    (item.box_quantity * (item.device_type.includes('1000') ? 3 : 6)))}</td>
                  <td>{item.box_quantity}</td>
                  <td>{item.box_size}</td>
                  <td>{item.mass.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="results-breakdown">
         <h3>Детали расчета</h3>
        {results.results.map((item, index) => (
          <div key={index} className="breakdown-item">
            <h4>{item.device_type}</h4>
            <ul>
               <li>
                <strong>Масса:</strong> {item.mass.toFixed(2)} кг 
                (масса устройств + масса коробок)
              </li>
               <li>
                <strong>Коробок нужно:</strong> {item.box_quantity} 
                (исходя из {item.in_box_num || (item.device_type.includes('TD BLE') ? 
                  (item.device_type.includes('1000') ? 4 : 8) : 
                  (item.device_type.includes('1000') ? 3 : 6))} устройств в коробке)
              </li>
               <li>
                <strong>Размеры коробки:</strong> {item.box_size} см
              </li>
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultsDisplay;